import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Button as MuiButton, CircularProgress } from '@mui/material';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const Button = ({
  label,
  color,
  variant,
  size,
  loading = false,
  disabled = false,
  icon,
  iconPosition = 'start',
  isFileUpload = false,
  onFileChange,
  onClick,
  ...props
}) => {
  const buttonProps = {
    color,
    variant,
    size,
    disabled: disabled || loading,
    onClick,
    ...props,
  };

  if (icon) {
    buttonProps[`${iconPosition}Icon`] = icon;
  }

  return (
    <MuiButton {...buttonProps} component={isFileUpload ? 'label' : 'button'}>
      {loading ? (
        <CircularProgress size={24} color="inherit" />
      ) : (
        <>
          {label}
          {isFileUpload && <VisuallyHiddenInput type="file" onChange={onFileChange} />}
        </>
      )}
    </MuiButton>
  );
};

export default Button;
